import useCurrentViewType from "@hooks/useCurrentViewType"

import { TIMELINE_VIEW_PARAM_SCROLL_POSITION } from "@constants/searchParams"

export function useJobsBackDestination(route: string) {
    const { currentViewType } = useCurrentViewType()

    return currentViewType === "timeline" ? `${route}?${TIMELINE_VIEW_PARAM_SCROLL_POSITION}=back_forward` : route
}
